angular.module('impactx.productcoding').component('ixProductCodingNestedTreeList', {
        bindings: {
            subEntry: '<',
            expand: '&',
            editEntry: '&',
            addEntries: '&',
            inconsistentTrns: '@',
            copyTrns: '@',
            fallbackTrns: '@',
            showAddEntries: '<'
        },
        controller: 'ProductCodingNestedTreeListCtrl',
        templateUrl: 'modules/productcoding/templates/nested-tree-list.html'
    }
);